import { render, staticRenderFns } from "./MessageTextTemplate.vue?vue&type=template&id=6e0b5870&"
import script from "./MessageTextTemplate.vue?vue&type=script&lang=js&"
export * from "./MessageTextTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports